'use client';

import { c as _c } from "react/compiler-runtime";
import { useSelector } from '@legendapp/state/react';
import { type DetailedHTMLProps, type HTMLAttributes } from 'react';
import { useIsClient } from '@/hooks/useIsClient';
import { cn } from '@/lib/cn';
import { useCarouselStateState } from './Carousel';
export type CarouselNavigationContainerProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
export function CarouselNavigationContainer(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const carouselState$ = useCarouselStateState();
  const isClient = useIsClient();
  let t1;
  if ($[4] !== carouselState$.active) {
    t1 = () => carouselState$.active.get();
    $[4] = carouselState$.active;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const active = useSelector(t1);
  if (!active || !isClient) {
    return null;
  }
  let t2;
  if ($[6] !== className) {
    t2 = cn("carousel-navigation absolute inset-0 z-1 pointer-events-none", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== props || $[10] !== t2) {
    t3 = <div className={t2} {...props}>{children}</div>;
    $[8] = children;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}